import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Simulate } from 'react-dom/test-utils';
import { reactEventTrigger } from '../react-helpers';

export type DriverFactory<TDriver extends BaseDriver> = (
  compFactory: ComponentFactory,
) => TDriver;

export interface BaseDriver {
  exists: () => boolean;
}

export interface ComponentFactory {
  element: Element | undefined;
  wrapper: any;
  component?: React.ReactElement<any>;
  eventTrigger: typeof Simulate;
}

function componentFactory(
  Component: React.ReactElement<any>,
): ComponentFactory {
  let element: HTMLDivElement | null;
  const eventTrigger = reactEventTrigger();

  const wrapperDiv = document.createElement('div');
  const root = createRoot(wrapperDiv!);
  root.render(<div ref={(r) => (element = r)}>{Component}</div>);
  return {
    element: element! && (element!.childNodes[0] as Element),
    wrapper: wrapperDiv,
    component: Component,
    eventTrigger,
  };
}

export function createDriverFactory<TDriver extends BaseDriver>(
  driverFactory: DriverFactory<TDriver>,
) {
  return (Component: React.ReactElement<any>) =>
    driverFactory(componentFactory(Component));
}
